// extracted by mini-css-extract-plugin
export default {"btn-settings":"tOFxXKfLpAndyJRBJB_4","active":"M6wCLfrCkRkccaaTxgB0"};